import { getPlatformInfo, PlatformEnum } from '@tencent/wphk-platform-adapter';
import { handleBigFont, setFontInfoInCache, disableFontSizeScale } from './font-scale-handle';
import { FontScaleObserver } from './font-scale-observer';

const { platformType } = getPlatformInfo();

function initWebFontScale() {
  // 写入css变量
  new FontScaleObserver((fontScale: number) => {
    document.documentElement.style.setProperty('--font-scale', `${fontScale}`);
    setFontInfoInCache(fontScale);
  });
  // 禁止页面大字体闪动
  handleBigFont();
}

function initLiteAppFontScale() {
  const { fontScale } = lite.system.getSystemInfo();
  if (!Number.isNaN(fontScale)) {
    // 写入css变量
    document.documentElement.style.setProperty('--font-scale', `${fontScale * 100}`);
  }
}

/**
 * 初始化字体缩放
 */
export function initFontScale(): void {
  switch (platformType) {
    case PlatformEnum.LiteApp:
      initLiteAppFontScale();
      break;
    case PlatformEnum.Web:
      initWebFontScale();
      break;
  }
}

/**
 * 禁用整个页面字体缩放
 */
export function disableFontScale(): void {
  switch (platformType) {
    case PlatformEnum.Web:
      disableFontSizeScale();
      break;
  }
}
